import { gql } from "@apollo/client";

export const CRM_CAMPAIGNS = gql`
  query CrmCampaigns($where: CrmCampaignWhereInput, $take: Int, $skip: Int, $orderBy: [JSONObject]) {
    crmCampaigns(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
      data {
        id
        name
        state
        sequenceId
        templateId
        scheduleId
        senderIds
        config
        health
        launchedAt
        pausedAt
        createdDate
        updatedDate
      }
      count
    }
  }
`;

export const CRM_CAMPAIGN = gql`
  query CrmCampaign($where: CrmCampaignWhereInput) {
    crmCampaign(where: $where) {
      id
      name
      state
      sequenceId
      templateId
      scheduleId
      senderIds
      config
      health
      launchedAt
      pausedAt
      createdDate
      updatedDate
    }
  }
`;

const crmCampaigns = { CRM_CAMPAIGNS, CRM_CAMPAIGN };
export default crmCampaigns;
